import { formatInTimeZone } from "date-fns-tz";
import { enGB } from "date-fns/locale/en-GB";
import { ReactNode } from "react";
import { useAppSelector } from "../../../lib/redux/hooks";
import { cloudsLabel, degreesToDirection } from "../../../lib/types";
import { Spinner } from "../../../ui/molecoles/spinner";
import { HeadingComponent } from "../../../ui/organisms/heading";
import { HeadingSize } from "../../../ui/organisms/heading/dto";

export function ArrivalAirportWeather() {
    const reportState = useAppSelector(state => state.report)

    let arrivalsList: ReactNode[] = []

    if (reportState.findByIdStatus === "loading") {
        return (
            <div className={"flex justify-center items-center flex-grow"}>
                <Spinner />
            </div>
        )
    }

    if (reportState.findByIdStatus === "successfully" && reportState.findByIdResponse !== undefined) {
        reportState.findByIdResponse.flight_info.arrival_airport_weather.hourly.filter(item => item.weather !== null && item.weather.length > 0).forEach((item) => {
            arrivalsList.push(
                <tr
                    className="bg-white h-[56px] border-b-[1px] border-b-neutral-100"
                >
                    <td className="py-4 px-4 text-text-sm cursor-pointer font-semibold text-neutral-850">
                        {new Date(item.day_time).toISOString() === "0001-01-01T00:00:00.000Z"
                            ? "-"
                            : formatInTimeZone(item.day_time, reportState.findByIdResponse?.flight_info.flight.arrival.airport.timezone!, "dd MMM yyyy HH:mm", { locale: enGB })
                        }
                    </td>
                    <td className="py-4 px-2 text-text-sm font-semibold text-neutral-600">{item.temp + " °C"}</td>
                    <td className="py-4 px-2 text-text-sm font-semibold text-neutral-600">{item.dew_point + " °C"}</td>
                    <td className="py-4 px-2 text-text-sm font-semibold text-neutral-600">
                        {item.humidity + "%"}
                    </td>
                    <td className="py-4 px-2 text-text-sm font-semibold text-neutral-600">
                        {degreesToDirection(item.wind_deg)}
                    </td>
                    <td className="py-4 px-2 text-text-sm font-semibold text-neutral-600">
                        {item.wind_speed + " Kts"}
                    </td>
                    <td className="py-4 px-2 text-text-sm font-semibold text-neutral-600">{item.wind_gust + " Kts"}</td>
                    {/* <td className="py-4 px-2 text-text-sm font-semibold text-neutral-600">{item.pressure + " hPa"}</td> */}
                    <td className="py-4 px-2 text-text-sm font-semibold text-neutral-600">{cloudsLabel(item.clouds)}</td>
                    <td className="py-4 px-2 text-text-sm font-semibold text-neutral-600">
                        {
                            item.weather[0].main === cloudsLabel(item.clouds) ?
                                "No significant weather" : item.weather[0].main
                        }
                    </td>
                </tr>
            )
        })
    }

    return (
        <div className={"flex gap-3 flex-col flex-grow"}>
            <HeadingComponent
                label={reportState.findByIdResponse?.flight_info.flight.arrival.airport.city! + " Airport" + " (" + reportState.findByIdResponse?.flight_info.flight.arrival.airport.code_iata + ")"}
                buttons={[]}
                size={HeadingSize.SM}
            />
            <div className="w-full flex flex-col gap-4 rounded-tr-xl rounded-tl-xl rounded-b-lg overflow-auto">
                <div>
                    <table className="w-full mb-3">
                        <thead className="h-[56px] bg-neutral-100 font-semibold text-neutral-500 text-text-xs">
                            <tr>
                                <th className="text-left">
                                    <div className="flex py-4 px-4 gap-1">
                                        TIME {"(" + reportState.findByIdResponse?.flight_info.flight.arrival.airport.timezone_abbr + ")"}
                                    </div>
                                </th>
                                <th className="text-left">
                                    <div className="flex py-4 px-2 gap-1">
                                        TEMPERATURE
                                    </div>
                                </th>
                                <th className="text-left">
                                    <div className="flex py-4 px-2 gap-1">
                                        DEW POINT
                                    </div>
                                </th>
                                <th className="text-left">
                                    <div className="flex py-4 px-2 gap-1">
                                        HUMIDITY
                                    </div>
                                </th>
                                <th className="text-left">
                                    <div className="flex py-4 px-2 gap-1">
                                        WIND
                                    </div>
                                </th>
                                <th className="text-left">
                                    <div className="flex py-4 px-2 gap-1">
                                        WIND SPEED
                                    </div>
                                </th>
                                <th className="text-left">
                                    <div className="flex py-4 px-2 gap-1">
                                        WIND GUST
                                    </div>
                                </th>
                                {/* <th className="text-left">
                                    <div className="flex py-4 px-2 gap-1">
                                        PRESSURE
                                    </div>
                                </th> */}
                                <th className="text-left">
                                    <div className="flex py-4 px-2 gap-1">
                                        CLOUDS
                                    </div>
                                </th>
                                <th className="text-left">
                                    <div className="flex py-4 px-2 gap-1">
                                        CONDITION
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                reportState.findByIdResponse?.flight_info.arrival_airport_weather.hourly.length === 0 ?
                                    <tr className="bg-white h-[56px] border-b-[1px] border-b-neutral-100">
                                        <td className="py-4 px-4 text-text-sm font-semibold text-neutral-850">No metars available</td>
                                    </tr>
                                    :
                                    arrivalsList
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}